import {addHash} from './addHash';

export function isCurrentHash(target?: string, currentHash: string = document.location.hash): boolean {
    return addHash(target) === addHash(currentHash);
}
